import { render, staticRenderFns } from "./waterSupply.component.vue?vue&type=template&id=058f58f2&scoped=true&"
import script from "./waterSupply.component.vue?vue&type=script&lang=js&"
export * from "./waterSupply.component.vue?vue&type=script&lang=js&"
import style0 from "./waterSupply.component.vue?vue&type=style&index=0&id=058f58f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f58f2",
  null
  
)

export default component.exports